import { Removable } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ tag, removable, removableId, project }) => {
    const removeTag = {
      [Removable.TASK]: repository.removeTagFromTask,
      [Removable.LIST]: repository.removeTagFromList,
      [Removable.MILESTONE]: repository.removeTagFromMilestone,
      [Removable.PROJECT]: repository.removeTagFromProject,
      [Removable.RESSOURCE]: repository.removeTagFromResource,
      [Removable.EVENT]: repository.removeTagFromEvent,
    };

    return present(
      removeTag[removable]
        ? removeTag[removable](tag, removableId)
            .then(() => ({ tag, removable, removableId, project }))
            .catch(() =>
              Promise.reject({ tag, removable, removableId, project }),
            )
        : Promise.reject({ tag, removable, removableId, project }),
    );
  };
}

export type { Interactor };

export { createInteractor };
